import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { Component, ViewEncapsulation } from '@angular/core';
import { fuseAnimations } from 'src/@fuse/animations/index';

@Component({
  selector: 'app-wellcome',
  templateUrl: './wellcome.component.html',
  styleUrls: ['./wellcome.component.scss'],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  animations: [
    fuseAnimations,
    trigger('stepAnimation', [
      state('in', style({ opacity: 1, transform: 'translateX(0)' })),
      transition(':enter', [
        style({ opacity: 0, transform: 'translateX(50px)' }),
        animate('300ms ease-in'),
      ]),
      transition(':leave', [
        animate(
          '300ms ease-out',
          style({ opacity: 0, transform: 'translateX(-50px)' }),
        ),
      ]),
    ]),
  ],
})
export class WellcomeComponent {}
